<nz-tabset [nzDestroyInactiveTabPane]="true">
  <nz-tab nzTitle="S3 Ingestion">
    <ng-template nz-tab>
      <app-file-upload></app-file-upload>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="File List">
    <ng-template nz-tab>
      <app-file-list></app-file-list>
    </ng-template>
  </nz-tab>
</nz-tabset>
